import script from "./getUserMedia.vue?vue&type=script&setup=true&lang=js"
export * from "./getUserMedia.vue?vue&type=script&setup=true&lang=js"

import "./getUserMedia.vue?vue&type=style&index=0&id=d19248bc&lang=less&scoped=true"

import exportComponent from "/data/home/csserver/project/cpcps/h5fe_cpcps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d19248bc"]])

export default __exports__